// removed by extract-text-webpack-plugin
module.exports = {"MacroLink":"MacroLink___orvYy","ul":"ul___3acYj","li":"li___l0e_Z","editing":"editing___1zAUP","flexy":"flexy___usmtl","new":"new___3TU1i","editAll":"editAll___2nyl5","noSafari":"noSafari___1lqoJ","dropdownBacker":"dropdownBacker___2bcTl","select":"select___208Ud","btn":"btn___2ie73","currentTab":"currentTab___23s_D","btnAdd":"btnAdd___2ibDQ","varList":"varList___2z3mq"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/VarList/styles.scss
// module id = 341
// module chunks = 0